import React from 'react';
import Login from './login';
import Checkout from './checkout';
import ChoicePayment from '../choice-payment';
import SbpPay from './sbp-pay';
import PushkinPay from './pushkin-card';
import Info from './info';

export default class Aside extends React.Component {
  state = {
    userPaymentMethods: [],
    orderId: null,
    dataPaymentMethods: {},
  };

  /**
   * Устанавливаем методы оплаты для данного пользователя
   * Анонимная функция для передачи в другие классы
   * @param {Array} value
   */
  setForUserPaymentMethods = value =>
    this.setState({ userPaymentMethods: value });

  /**
   * Устанавливаем id заказа
   * Анонимная функция для передачи в другие классы
   * @param {String} value
   */
  setOrderId = value => {
    this.setState({ orderId: value });
    this.props.setOrderId(value);
  };

  /**
   * Устанавливаем методы оплаты для заказа
   * Анонимная функция для передачи в другие классы
   * @param {Array} value
   */
  setDataPaymentMethods = value => this.setState({ dataPaymentMethods: value });

  /**
   * Сохраняем выборанные места для не залогиненного пользователя
   * @param e
   */
  saveUserChoose = e => {
    e.preventDefault();
    const { selected, sessionId } = this.props;

    const userChoosenPlaces = {
      place: selected,
      session: sessionId,
      previousPage: window.location.pathname,
    };

    localStorage.setItem('userChooseInfo', JSON.stringify(userChoosenPlaces));

    window.location.href = e.target.getAttribute('href');
  };

  /**
   * Рендерим html
   * @returns {JSX.Element|null}
   */
  render() {
    const { route, routeLogin, updateUser } = this.props;

    //Форма авторизации
    if (this.props.step === 'login') {
      return (
        <Login
          onBackClick={() => this.props.onBackClick()}
          checkout={this.props.checkout}
          route={routeLogin}
          updateUser={user => updateUser(user)}
          saveUserChoose={e => this.saveUserChoose(e)}
        />
      );
    }

    //Отображение информации о сеансе или рекламы
    if (this.props.step === 'info') {
      return (
        <Info
          route={route}
          session={this.props.session}
          onInfo={() => this.props.onInfo()}
          onCheckout={() => this.props.onCheckout()}
          onBackClick={() => this.props.onBackClick()}
          beforeStep={this.props.beforeStep}
          sessionInfo={this.props.sessionInfo}
        />
      );
    }

    //Оформление заказа
    if (this.props.step === 'checkout') {
      return (
        <Checkout
          selected={this.props.selected}
          session={this.props.session}
          user={this.props.user}
          checkout={this.props.checkout}
          onBackClick={() => this.props.onBackClick()}
          showTooltip={() => this.props.showTooltip()}
          onEditCheckout={(name, val) => this.props.onEditCheckout(name, val)}
          route={route}
          returnError={value => this.props.returnError(value)}
          sessionId={this.props.sessionId}
          onSchema={() => this.props.onSchema()}
          onLogin={() => this.props.onLogin()}
          onInfo={() => this.props.onInfo()}
          onCheckout={() => this.props.onCheckout()}
          onChoicePayment={() => this.props.onChoicePayment()}
          amount={this.props.amount}
          maxBonusPay={this.props.maxBonusPay}
          saveUserChoose={e => this.saveUserChoose(e)}
          enableTimerCallback={this.props.enableTimerCallback}
          setForUserPaymentMethods={this.setForUserPaymentMethods}
          setOrderId={this.setOrderId}
          setDataPaymentMethods={this.setDataPaymentMethods}
          sessionInfo={this.props.sessionInfo}
        />
      );
    }

    //Выбор способа оплаты
    if (this.props.step === 'choicePayment') {
      return (
        <ChoicePayment
          amount={this.props.amount}
          checkout={this.props.checkout}
          user={this.props.user}
          onBackClick={() => this.props.onBackClick()}
          onSbpPay={() => this.props.onSbpPay()}
          onPushkinPay={() => this.props.onPushkinPay()}
          selected={this.props.selected}
          showTooltip={() => this.props.showTooltip()}
          userPaymentMethods={this.state.userPaymentMethods}
          enableTimerCallback={this.props.enableTimerCallback}
          orderId={this.state.orderId}
          dataPaymentMethods={this.state.dataPaymentMethods}
        />
      );
    }

    // Qr-Код для оплаты СБП
    if (this.props.step === 'sbpPay') {
      return (
        <SbpPay
          amount={this.props.amount}
          checkout={this.props.checkout}
          user={this.props.user}
          onBackClick={() => this.props.onBackClick()}
          selected={this.props.selected}
          orderId={this.state.orderId}
        />
      )
    }

    // Qr-Код для оплаты СБП
    if (this.props.step === 'pushkinPay') {
      return (
        <PushkinPay
          amount={this.props.amount}
          checkout={this.props.checkout}
          user={this.props.user}
          showTooltip={() => this.props.showTooltip()}
          onBackClick={() => this.props.onBackClick()}
          onEditCheckout={(name, val) => this.props.onEditCheckout(name, val)}
          selected={this.props.selected}
          orderId={this.state.orderId}
        />
      )
    }

    return null;
  }
}
